<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  destroyed() {
    sessionStorageProxy.clear()
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue